// © Copyright 2026 Emman Consulting SAS
import React, { useState } from "react";
import { PANINI } from "../../data/albumData.js";
import { I18N } from "../../i18n.js";
import { useLongPress } from "../../hooks/useLongPress.js";

const PaniniSection = React.memo(function PaniniSection({ col, onTap, onReset, filter, lang }) {
  const t = I18N[lang || "es"];
  const [open, setOpen] = useState(false);
  const owned = PANINI.filter((s) => col[s.code]?.owned).length;
  const pct = Math.round(owned / 1 * 100);
  const { handlers } = useLongPress({ onTap, onReset });

  return (
    <div className="fwcbox">
      <div className="fwchdr" onClick={() => setOpen((o) => !o)}>
        <div className="fwchl">
          <i className="fi fi-sr-ball" style={{ fontSize: 18, lineHeight: 1 }} />
          <div>
            <div className="fwcttl">{t.logoOficialTitle}</div>
            <div className="fwcsub">{t.logoOficialSub}</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ textAlign: "right" }}>
            <span className="fwcpill">{pct}%</span>
            <div className="gcnt">{owned}/1</div>
          </div>
          <span className={"chv" + (open ? " open" : "")}>▼</span>
        </div>
      </div>
      {open && (
        <div className="sdots" style={{ padding: 16 }}>
          {PANINI.map((s) => {
            const st = col[s.code] || { owned: false, quantity: 0 };
            const isDupe = st.owned && st.quantity > 0;
            if (filter === "missing" && st.owned) return null;
            if (filter === "dupes" && st.quantity === 0) return null;
            return (
              <div
                key={s.code}
                className={"sdot-fwc" + (isDupe ? " dupe" : st.owned ? " owned" : "")}
                data-qty={isDupe ? "×" + st.quantity : ""}
                data-num="00"
                title={s.label}
                {...handlers(s.code)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
});

export default PaniniSection;
